import AgeFilter from './AgeFilter';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import DateFilter from './DateFilter';
import DatePicker from './DatePicker';
import DateRange from './DateRange';
import HorizontalRule from './HorizontalRule';
import LessonCategory from './LessonCategory';
import MilestoneCategories from './MilestoneCategories';
import { FilterItemRegistrationStatus } from './RegistrationStatus';
import Role from './Role';
import Room from './Room';
import Select from './Select';
import SignFilter from './SignFilter';
import Tags from './Tags';
import Typeahead from './Typeahead';

export default {
  room: Room,
  tags: Tags,
  select: Select,
  'multi-select': Select,
  'date-range': DateRange,
  'date-picker': DatePicker,
  'lesson-category': LessonCategory,
  'milestone-categories': MilestoneCategories,
  checkbox: Checkbox,
  'checkbox-group': CheckboxGroup,
  typeahead: Typeahead,
  'sign-filter': SignFilter,
  'age-filter': AgeFilter,
  'date-filter': DateFilter,
  'registration-status': FilterItemRegistrationStatus,
  hr: HorizontalRule,
  role: Role
};
